import apolloClient from "../apolloClient";
import { GET_STATES, GET_COUNTRIES } from "./graphql";

class LookupService {
	async fetchCountryList() {
		const { data } = await apolloClient.query({
			query: GET_COUNTRIES,
		});
		return data.countries.nodes;
	}

	async fetchStateList(countyId) {
		const { data } = await apolloClient.query({
			query: GET_STATES,
			variables: {
				countryId: countyId,
			},
		});
		return data.states.nodes;
	}
}

export default new LookupService();
